import styled from 'styled-components';
import { Upload } from 'antd';
import { Upload as RegularUploadIcon } from '@styled-icons/boxicons-regular/Upload';
import { Attachment } from '@styled-icons/entypo/Attachment';
import { Trash } from '@styled-icons/bootstrap/Trash';

const { Dragger } = Upload;

export const UploadAreaContainer = styled(Dragger)`
  & div.ant-upload-drag-container > div {
    display: flex;
    flex-direction: column;
    margin: auto;
    max-width: 14rem;

    & > span {
      font-size: 1rem;
      color: ${({ theme }) => theme.colors.grayDark4};
      font-family: ${({ theme }) => theme.fonts.workSans};
      margin-top: 0.5rem;
    }
  }

  & .upload-button-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;

export const UploadIcon = styled(RegularUploadIcon)`
  width: 1.4rem;
  margin-right: 0.5rem;
`;

export const UploadedFile = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 1rem 0;
  padding: 0 0.5rem;
  transition: opacity 0.5s;

  &:hover {
    background-color: ${({ theme }) => theme.colors.gray1};
  }

  & > div > span {
    font-size: 0.875rem;
    color: ${({ theme }) => theme.colors.blue};
  }

  & > button {
    border: none;
    background: none;
    outline: none;
    cursor: pointer;
  }

  &.remove-element {
    opacity: 0;
  }
`;

export const AttachmentIcon = styled(Attachment)`
  width: 1rem;
  margin-right: 0.5rem;
`;

export const TrashIcon = styled(Trash)`
  color: ${({ theme }) => theme.colors.red};
  width: 1rem;
`;
